module.exports = __webpack_public_path__ + "static/media/ImgMBTI_SOTC.8a1deb11.png";